<template>
  <modal :open="open" @close="close()">
    <template v-slot:modelcontent>
      <div class="sm:rounded-lg">
        <div class="mb-5">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Floorplans
          </h3>
          <p class="mt-1 text-sm text-gray-500">
            Enter information about a Floor Plan here
          </p>
        </div>
        <div class="md:grid md:grid-cols-2 md:gap-6">
          <template v-if="form">
            <div class="col-span-2">
              <input-field
                  type="file"
                  label="Floorplan Photo"
                  name="floorplan_file"
                  :errors="errors?.floorplan_file"
                  required
                  v-model="form.floorplan_file"
              />
              <div v-if="form.current_document_data">
                <a
                    target="_blank"
                    :href="form.current_document_data.file_path"
                >{{ form.current_document_data.name }}</a>
              </div>
            </div>
            <div class="col-span-2">
              <input-field
                  type="text"
                  label="Property UPRN"
                  name="property_uprn"
                  required
                  :errors="errors?.property_uprn"
                  v-model="form.property_uprn"
              />
            </div>
            <div class="col-span-2">
              <input-field
                  type="text"
                  label="Property Name"
                  name="property_name"
                  required
                  :errors="errors?.property_name"
                  v-model="form.property_name"
              />
            </div>
            <div class="col-span-2">
              <input-field
                  type="text"
                  label="Building Name"
                  name="building_name"
                  required
                  :errors="errors?.building_name"
                  v-model="form.building_name"
              />
            </div>
            <div class="col-span-2">
              <input-field
                  type="text"
                  label="Floor"
                  name="floor"
                  required
                  :errors="errors?.floor"
                  v-model="form.floor"
              />
            </div>
          </template>
        </div>
      </div>

      <div class="flex justify-end mt-5">
        <cancel-button :disabled="isLoading" @click="close()"/>
        <save-button :disabled="isLoading" @click="handleSaveClick()"/>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  name: 'NoAccessAreaModal',

  props: {
    registerId: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    selectedItem: {
      type: Object
    }
  },

  watch: {
    open(newVal) {
      this.errors = null;

      if (newVal && this.selectedItem) {
        this.loadData();
      }

      if (newVal && !this.selectedItem) {
        this.form = this.getEmpty();
      }
    }
  },

  data() {
    return {
      errors: null,
      form: null,
      isLoading: false
    }
  },

  methods: {
    setErrors(error) {
      if (error.response.status === 422) {
        this.errors = error.response.data.errors
      } else {
        this.$emit('error', error)
      }
    },

    handleSaveClick() {
      const formData = new FormData();
      this.buildFormData(formData, this.form);

      if (this.selectedItem)
        this.update(formData);
      else
        this.create(formData);
    },

    create(formData) {
      axios.post(route('ajax.register.floorplan.create', [this.registerId]), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            this.$emit('created', response);
            this.form = this.getEmpty();
          })
          .catch(error => {
            this.setErrors(error);
          })
    },

    update(formData) {
      axios.post(route('ajax.register.floorplan.update', [this.registerId, this.selectedItem.id]),
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$emit('updated', response);
            this.form = this.getEmpty();
          })
          .catch(error => {
            this.setErrors(error);
          })
    },

    close: function () {
      this.$emit('closed');
    },

    loadData() {
      this.isLoading = true;
      axios.get(route('ajax.register.floorplan.view', [this.registerId, this.selectedItem.id]))
          .then(response => {
            this.form = response.data;
          })
          .catch(error => {
            this.setErrors(error)
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    getEmpty() {
      return {
        floor: null,
        floorplan_file: null
      }
    }
  }
}
</script>
